import apiClient from './api-client';

export default {
  faqSearchPredictions(payload, langCode) {
    return apiClient.post(`/faq/${langCode}/search?term=${payload.term}`, { id: payload.id });
  },
  searchResults(payload, langCode) {
    return apiClient.post(`/faq/${langCode}/search/results`, payload);
  },
};
